<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher un échantillon..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <!-- <button class="btn btn-outline-primary btn-sm rounded-start-pill " (click)="openModal(content)">
                    <i class="fa-solid fa-plus  px-2"></i>
                </button>-->
        <mat-card-subtitle>
            <div class="btn-group rounded-pill" role="group" aria-label="Basic example">
                
       
                <div class="btn-group dropdown">
                    <button type="button" class="btn btn-outline-primary btn-sm rounded-start-pill "
                            data-bs-toggle="dropdown"
                    >
                        @if (loadingRapport || loadingPdfGen || loadingOT || loadingExcel) {
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="px-2">Chargement</span>
                        } @else {
                            <i class="fa-solid fa-flask px-4"></i>
                        }
                    </button>
                    <ul class="dropdown-menu">
                        <div class="row d-flex justify-content-center" style="width: 210px">
                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingOT"
                                        (click)="generateAnalyseResults()">
                                    @if (loadingOT) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span class="px-2">Order de travail</span>
                                    }
                                </button>
                            </div>
                            <!--
                            <div class="col-lg-12">
                            <button
                                style="width: 170px"
                                class="btn btn-outline-success btn-sm my-1 mx-2"
                                (click)="generateFichePaillasse()"
                                >

                                @if (loadingFichePaillasse) {
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                <span class="px-2">Génération...</span>
                                } @else {
                                <span>
                                    <i class="fa-solid fa-flask px-2"></i>
                                    Fiche de paillasse
                                </span>
                                }
                            </button>
                            </div>-->

                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingExcel"
                                        (click)="openImportModal(importModal)">
                                    @if (loadingExcel) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span> <i class="fa-regular fa-circle-up px-2"></i>Import Donneés</span>
                                    }
                                </button>
                            </div>

                           <div class="col-lg-12 ">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2"
                                        (click)="printSample()">
                                    @if (loadingPdfGen) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span><i class="fa-regular fa-circle-down px-2"></i>Codes barre</span>
                                    }

                                </button>
                            </div>
                            <div class="col-lg-12 ">
                                <button
                                style="width: 170px"
                                class="btn btn-outline-primary btn-sm my-1 mx-2"
                                [disabled]="loadingRapport"
                                (click)="openRapportModal(rapportModal)"
                                >
                                <i class="fa-regular fa-circle-down px-2"></i>
                                Rapport
                                </button>
                            </div>

                              
                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2 "
                                        [disabled]="loadingExcel"
                                        (click)="downloadExcel()">
                                    @if (loadingExcel) {
                                        <span class="spinner-grow spinner-grow-sm" role="status"
                                              aria-hidden="true"></span>
                                        <span class="px-2">Chargement</span>
                                    } @else {
                                        <span> <i class="fa-regular fa-circle-down px-2"></i>Excel</span>
                                    }
                                </button>
                            </div>

                            <div class="col-lg-12">
                                <button style="width: 170px" class="btn btn-outline-primary btn-sm my-1 mx-2"
                                        (click)="openAffectationModal(affectationModal)">
                                    <i class="fa-solid fa-user-check px-2"></i>
                                    Affecter utilisateur
                                </button>
                            </div>                           
                            <!--<div class="col-lg-12" *ngIf="!showRejected">
                                <button style="width: 170px" 
                                        class="btn btn-outline-danger btn-sm my-1 mx-2"
                                        (click)="showRejectedSamples()">
                                    <i class="fa-solid fa-ban px-2"></i> Voir les rejetés
                                </button>
                            </div>
                            <div class="col-lg-12" *ngIf="showRejected">
                                <button style="width: 170px"
                                        class="btn btn-outline-primary btn-sm my-1 mx-2"
                                        (click)="showValidatedSamples()">
                                    <i class="fa-solid fa-arrow-left px-2"></i> Retour aux validés
                                </button>
                            </div>-->

                        </div>
                        
                    </ul>
                </div>
                <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                        aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders  px-2"></i>
                </button>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource1" matSort>

                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell
                            *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllSamplesSelected"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isAllSamplesSelected" (change)="handleSelection(element)"/>
                        </td>
                    </ng-container>
                   <!-- <ng-container matColumnDef="id">
                        <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
                    </ng-container>                    

                    sampleCode Column -->
                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code</th>
                        <td mat-cell *matCellDef="let element"> <a [routerLink]="['/clients-sample-details', element.id]">
                            {{ element.sampleCode }}
                        </a></td>
                    </ng-container>
                    <ng-container matColumnDef="departementName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Département</th>
                        <td mat-cell *matCellDef="let element"> {{ element.departementName }}</td>
                    </ng-container>
                    <ng-container matColumnDef="conditionnement">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Conditionnement</th>
                        <td mat-cell *matCellDef="let element"> {{ element.conditionnement }}</td>
                    </ng-container>
                    <ng-container matColumnDef="conditionnementReception">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> conditionnement Réception</th>
                        <td mat-cell *matCellDef="let element"> {{ element.conditionnementReception }}</td>
                    </ng-container>
                    <!-- sampleType Column -->
                    <ng-container matColumnDef="sampleType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
                        <td mat-cell *matCellDef="let element"> {{ element.typeSampleName }}</td>
                    </ng-container>

                    <!-- collectedBy Column -->
                    <ng-container matColumnDef="collectedById">
                        <th mat-header-cell *matHeaderCellDef> Collecté par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.collectedByUsername }}</td>
                    </ng-container>
                    <!-- collectionDate Column-->
                    <ng-container matColumnDef="collectionDate">
                        <th mat-header-cell *matHeaderCellDef> Date de collection</th>
                        <td mat-cell *matCellDef="let element"> {{ element.collectionDate | date: 'short' }}</td>
                    </ng-container>

                    <!-- updateDate Column 
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef> Dernière mise à jour</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate | date: 'short' }}</td>
                    </ng-container>-->

                    <!-- dateReception Column -->
                    <ng-container matColumnDef="dateReception">
                        <th mat-header-cell *matHeaderCellDef> Date de réception</th>
                        <td mat-cell *matCellDef="let element"> {{ element.dateReception | date: 'short' }}</td>
                    </ng-container>

                    <!-- qtePre Column -->
                    <ng-container matColumnDef="qtePre">
                        <th mat-header-cell *matHeaderCellDef> Quantité prélevée</th>
                        <td mat-cell *matCellDef="let element"> {{ element.qtePre }}</td>
                    </ng-container>

                    <!-- priorite Column -->
                    <ng-container matColumnDef="priorite">
                        <th mat-header-cell *matHeaderCellDef> Priorité</th>
                        <td mat-cell *matCellDef="let element"> {{ element.priorite }}</td>
                    </ng-container>
    
                    <!-- volume Column -->
                    <ng-container matColumnDef="volume">
                        <th mat-header-cell *matHeaderCellDef> Volume</th>
                        <td mat-cell *matCellDef="let element"> {{ element.volume }}</td>
                    </ng-container>

     
   
                    <!-- comments Column
                    <ng-container matColumnDef="comments">
                        <th mat-header-cell *matHeaderCellDef> Commentaires</th>
                        <td mat-cell *matCellDef="let element"> {{ element.remarques  || '–' }}</td>
                    </ng-container>-->

        
                    <!-- dateProduction Column -->
                    <ng-container matColumnDef="dateProduction">
                        <th mat-header-cell *matHeaderCellDef> Date de production </th>
                        <td mat-cell *matCellDef="let element"> {{ element.dateProduction | date:'dd/MM/yyyy' }} </td>
                    </ng-container>

                    <!-- dateLimiteConsommation Column -->
                    <ng-container matColumnDef="dateLimiteConsommation">
                        <th mat-header-cell *matHeaderCellDef> Date limite de consommation </th>
                        <td mat-cell *matCellDef="let element"> {{ element.dateLimiteConsommation | date:'dd/MM/yyyy' }} </td>
                    </ng-container>

                    <!-- referenceInterne Column -->
                    <ng-container matColumnDef="referenceInterne">
                        <th mat-header-cell *matHeaderCellDef> Référence interne </th>
                        <td mat-cell *matCellDef="let element"> {{ element.referenceInterne }} </td>
                    </ng-container>

                    <!-- temperaturePrelevement Column -->
                    <ng-container matColumnDef="temperaturePrelevement">
                        <th mat-header-cell *matHeaderCellDef> Température prélèvement </th>
                        <td mat-cell *matCellDef="let element"> {{ element.temperaturePrelevement }} </td>
                    </ng-container>

                    <!-- temperatureReception Column -->
                    <ng-container matColumnDef="temperatureReception">
                        <th mat-header-cell *matHeaderCellDef> Température réception </th>
                        <td mat-cell *matCellDef="let element"> {{ element.temperatureReception }} </td>
                    </ng-container> 
                    <ng-container matColumnDef="propreteContamination">
                        <th mat-header-cell *matHeaderCellDef> Propreté / contamination visible  </th>
                        <td mat-cell *matCellDef="let element"> {{ element.propreteContamination  || '–'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="scelleIntact">
                        <th mat-header-cell *matHeaderCellDef> Scellé Intact </th>
                        <td mat-cell *matCellDef="let element"> {{ element.scelleIntact  || '–'}} </td>
                    </ng-container> 
                    <ng-container matColumnDef="scelle">
                        <th mat-header-cell *matHeaderCellDef> Scellé </th>
                        <td mat-cell *matCellDef="let element"> {{ element.scelle ? 'Oui' : 'Non' }} </td>
                    </ng-container> 
                    <ng-container matColumnDef="volumeSuffisant">
                        <th mat-header-cell *matHeaderCellDef> Volume Suffisant </th>
                        <td mat-cell *matCellDef="let element"> {{ element.volumeSuffisant  || '–'}} </td>
                    </ng-container>  
                    <ng-container matColumnDef="etiquetageLisible">
                        <th mat-header-cell *matHeaderCellDef> Etiquitage Lisible </th>
                        <td mat-cell *matCellDef="let element"> {{ element.etiquetageLisible  || '–' }} </td>
                    </ng-container>   
                    <ng-container matColumnDef="socialReason">
                        <th mat-header-cell *matHeaderCellDef> Client </th>
                        <td mat-cell *matCellDef="let element"> {{ element.clientName }}</td>
                    </ng-container>

                    <!-- matriceName Column -->
                    <ng-container matColumnDef="matriceName">
                        <th mat-header-cell *matHeaderCellDef> Matrice</th>
                        <td mat-cell *matCellDef="let element"> {{ element.matriceName }}</td>
                    </ng-container>

                    <!-- nameCreatedBy Column 
                    <ng-container matColumnDef="nameCreatedBy">
                        <th mat-header-cell *matHeaderCellDef> Créé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.nameCreatedBy }}</td>
                    </ng-container>-->
                    <!-- nameCreatedBy Column -->
                    <ng-container matColumnDef="methode">
                        <th mat-header-cell *matHeaderCellDef> Méthode</th>
                        <td mat-cell *matCellDef="let element"> {{ element.methodeName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="batchId">
                        <th mat-header-cell *matHeaderCellDef> Lot </th>
                        <td mat-cell *matCellDef="let element"> {{ element.batchReference  || '–' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="dureeRespectee">
                        <th mat-header-cell *matHeaderCellDef> Délai </th>
                        <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="element.dureeRespectee === false || element.dureeRespectee == null" class="error-icon">error_outline</mat-icon>
                        <mat-icon *ngIf="element.dureeRespectee === true" class="valid">check_circle</mat-icon>
                    </td>
                      </ng-container>

                    <!-- status Column -->
                    <ng-container matColumnDef="withOt">
                        <th mat-header-cell *matHeaderCellDef> Status OT</th>
                        <td mat-cell *matCellDef="let element">
                            <span
                                [ngClass]="{
                                    'calcule': element.withOt,
                                    'enattente': !element.withOt
                                }"
                                class="daxa-badge d-inline-block">
                                {{ element.withOt ? 'Avec OT' : 'Sans OT' }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- codeAT Column -->
                    <ng-container matColumnDef="codeAT">
                        <th mat-header-cell *matHeaderCellDef> Type analyse</th>
                        <td mat-cell *matCellDef="let element"> {{ element.typeAnalyseName }}</td>
                    </ng-container>

                    <ng-container matColumnDef="terrainVarPlante">
                        <th mat-header-cell *matHeaderCellDef> Terrain</th>
                        <td mat-cell *matCellDef="let element"> {{ element.terrainVarPlante || '–' }}</td>
                    </ng-container>
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                            <!--
                                <button type="button" mat-button matTooltip="Visualiser les détails"
                                        matTooltipPosition="above" (click)="openViewModel(element)"
                                >
                                    <i class="material-symbols-outlined">
                                        visibility
                                    </i>
                                </button>
                                
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element)">
                                    <i class="material-symbols-outlined text-primary">
                                        brush
                                    </i>
                                </button>
                                -->
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">
                                        delete
                                    </i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"
    [ngClass]="{ 'row-rejected': row.sampleStatus === 'REJETE' }">
</tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" *ngIf="!loadingTable">Aucun résultat trouvé pour échantillions</td>
                    </tr>
                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

        </div>

    </mat-card-content>
</mat-card>

<ng-template #affectationModal let-modal>
    <div>
        <div class="modal-body">
            <form [formGroup]="formU">
                <!-- Sélection de l'utilisateur -->
                <div class="form-group">
                    <h5 class="modal-title">Affecter un utilisateur</h5>
                    <select class="form-control" formControlName="userId">
                        <option *ngFor="let user of userList" [value]="user.id">{{ user.username }}</option>
                    </select>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button class="btn btn-outline-secondary rounded-pill px-4" (click)="modal.dismiss()">Annuler</button>
            <button class="btn btn-success rounded-pill px-4 fw-bold shadow-sm" (click)="affectUser()">Affecter</button>
        </div>

    </div>
</ng-template>

  
<!-- modal template for editing -->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Modifier échantillon
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="updateSample()">
                <div class="row">
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Code èchantillion</mat-label>
                            <input matInput readonly formControlName="sampleCode" placeholder="Ex. 001">
                            <mat-error *ngIf="form.get('sampleCode')?.hasError('required')">Code d'échantillon requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Lot</mat-label>
                        <mat-select formControlName="batchId" placeholder="Selectionner le lot">
                            <mat-option [value]="null">Aucun lot</mat-option> <!-- Option vide -->
                            <mat-option *ngFor="let lot of lotList" [value]="lot.id">
                            {{ lot.batchName }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                    
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Producteur</mat-label>
                            <mat-select formControlName="clientId" placeholder="Selectionner le client">
                                @for (cl of clientList; track cl.id) {
                                    <mat-option [value]="cl.id">{{ cl.socialReason }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ requis</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Terrain</mat-label>
                        <mat-select formControlName="terrainId" placeholder="Selectionner le terrain">
                            <mat-option [value]="null">Aucun terrain</mat-option> <!-- Option vide -->
                            <mat-option *ngFor="let terrain of filteredTerrains" [value]="terrain.id">
                            {{ terrain.varPlante }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25" appearance="fill">
                          <mat-label>Collecté Par</mat-label>
                          <mat-select formControlName="collectedById" placeholder="Sélectionnez un préleveur" required>
                            <mat-option *ngFor="let user of preleveurs" [value]="user.id">
                              {{ user.name }} ({{ user.username }})
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="form.get('collectedById')?.hasError('required')">
                            Collecté Par requis
                          </mat-error>
                        </mat-form-field>
                      </div>
                      

                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Méthode</mat-label>
                            <input matInput formControlName="methode" placeholder="Ex. Methode">
                            <mat-error *ngIf="form.get('methode')?.hasError('required')">Methode requis
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date de collecte</mat-label>
                            <input matInput readonly [matDatepicker]="picker"
                                   formControlName="collectionDate">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('collectionDate')?.hasError('required')">Date de collecte
                                requise
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                    Date de réception-->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date de réception</mat-label>
                            <input matInput readonly [matDatepicker]="picker1"
                                   formControlName="dateReception">
                            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1 class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('dateReception')?.hasError('required')">Date de réception
                                requise
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Type d'échantillion</mat-label>
                            <mat-select matSelect formControlName="sampleType" placeholder="Selectionner le type d'échantillon">
                                @for (sample of productList; track sample.id) {
                                    <mat-option [value]="sample.id">{{ sample.productName }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('sampleType')?.hasError('required')">Type d'échantillion est requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Location</mat-label>
                            <input matInput formControlName="location" placeholder="Ex. Casablanca">
                            <mat-error *ngIf="form.get('location')?.hasError('required')">Source échantillion requis
                            </mat-error>
                        </mat-form-field>
                    </div>
     
                    <!--                    Quantité prélevée-->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Quantité prélevée</mat-label>
                            <input matInput type="number" formControlName="qtePre" placeholder="Ex. 1">
                            <mat-error *ngIf="form.get('qtePre')?.hasError('required')">Quantité prélevée requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Date de production -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Date de production</mat-label>
        <input matInput type="date" formControlName="dateProduction">
        <mat-error *ngIf="form.get('dateProduction')?.hasError('required')">
            Date de production requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Date limite de consommation -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Date limite de consommation</mat-label>
        <input matInput type="date" formControlName="dateLimiteConsommation">
        <mat-error *ngIf="form.get('dateLimiteConsommation')?.hasError('required')">
            DLC requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Référence interne -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Référence interne</mat-label>
        <input matInput formControlName="referenceInterne" placeholder="Ex. REF-2024-001">
        <mat-error *ngIf="form.get('referenceInterne')?.hasError('required')">
            Référence requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Température prélèvement -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Température prélèvement (°C)</mat-label>
        <input matInput type="number" formControlName="temperaturePrelevement" placeholder="Ex. 4">
        <mat-error *ngIf="form.get('temperaturePrelevement')?.hasError('required')">
            Température au prélèvement requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Température réception -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Température réception (°C)</mat-label>
        <input matInput type="number" formControlName="temperatureReception" placeholder="Ex. 6">
        <mat-error *ngIf="form.get('temperatureReception')?.hasError('required')">
            Température à la réception requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Visa -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Visa</mat-label>
        <input matInput formControlName="visa" placeholder="Visa qualité">
        <mat-error *ngIf="form.get('visa')?.hasError('required')">
            Visa requis
        </mat-error>
    </mat-form-field>
</div>

                    <!--                    Priorité-->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Priorité</mat-label>
                            <input matInput type="number" formControlName="priorite" placeholder="Ex. 1">
                            <mat-error *ngIf="form.get('priorite')?.hasError('required')">Champ requis
                            </mat-error>
                            <mat-error *ngIf="form.get('priorite')?.hasError('min')">La Priorité doit être supérieure ou égale 1 .</mat-error>
                            <mat-error *ngIf="form.get('priorite')?.hasError('max')">La Priorité doit être inférieure ou égale 3.</mat-error>
                        </mat-form-field>
                    </div>


                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>volume</mat-label>
                            <input matInput formControlName="volume" placeholder="Ex. volume">
                            <mat-error *ngIf="form.get('volume')?.hasError('required')">Volume requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Champ Statut de l'échantillon -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
      <mat-label>Statut de l'échantillon</mat-label>
      <mat-select formControlName="sampStatus">
        <mat-option value="CONFORME">Conforme</mat-option>
        <mat-option value="NON_CONFORME">Non conforme</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  


  
  <div class="col-sm-6 col-lg-12 mb-3" *ngIf="form.get('sampStatus')?.value === 'NON_CONFORME'">
    <mat-form-field>
      <mat-label>Note</mat-label>
      <input matInput formControlName="note" placeholder="Saisir une note">
    </mat-form-field>
  </div>


                    <div class="col-sm-6 col-lg-12 mb-3">
                        <mat-form-field>
                            <mat-label>Commentaire</mat-label>
                            <textarea matInput formControlName="comments"
                                      placeholder="Ex. échantillon du ..."></textarea>
                        </mat-form-field>
                    </div>

                    <!--                    Matrices-->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Matrices</mat-label>
                            <mat-select matSelect formControlName="matriceId" placeholder="Selectionner la matrice"
                                        (selectionChange)="fetchTypeAnalyseList()">
                                @for (mat of matriceList; track mat.id) {
                                    <mat-option [value]="mat.id">{{ mat.nom }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('matriceId')?.hasError('required')">Champ requis</mat-error>
                        </mat-form-field>
                    </div>
                    <!--                    Type d'analyse-->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Type d'analyse</mat-label>
                            <mat-select matSelect formControlName="idAT"
                                        (selectionChange)="fetchParametres()">
                                @for (st of typeAnalyseList; track st.id) {
                                    <mat-option [value]="st.id">{{ st.codeAT }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('idAT')?.hasError('required')">Champ requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                    Parametre-->
                    <div class="col-sm-6 col-lg-12 pt-3 border-top p-3">
                        <div class="fw-bold">Paramètres :</div>

                            @for (param of paramList; track $index) {
                            <div class="row mt-3">
                                <div class="col-sm-6 col-lg-3">
                                <div class="fw-bold">Code Paramètre :</div>
                                <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg-3">
                                <div class="fw-bold">Norme :</div>
                                <p>{{ param.description || 'N/A' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg-3">
                                <div class="fw-bold">Technique :</div>
                                <p>{{ param.technique || 'N/A' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg-3">
                                <div class="fw-bold">Description :</div>
                                <p>{{ param.norme || 'N/A' }}</p>
                                </div>
                            </div>
                            }
                            @empty {
                            <p class="text-muted">Aucun paramètre</p>
                            }

                    </div>

                </div>
                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Enregister</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for add -->
<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Créer un échantillon
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveSample()">
                <div class="row">
                    <div *ngIf="selectedLotId && selectedLotId > 0">
                        <p *ngIf="getRemainingSamples(selectedLotId) > 0" class="alert alert-info" style="margin-bottom:15px">
                            Ce lot permet encore 
                            <strong>{{ getRemainingSamples(selectedLotId) }}</strong> 
                            échantillon(s) au maximum.
                        </p>
                          
                        <p *ngIf="getRemainingSamples(selectedLotId) <= 0" class="alert alert-danger" style="margin-bottom:15px">
                            Ce lot a atteint le <strong>nombre maximal</strong> d’échantillons autorisés. 
                            Vous ne pouvez plus en ajouter.
                        </p>
                    </div>

        <mat-form-field appearance="fill" class="w-100" style="margin-bottom: 10px;">
        <mat-label>Type d'échantillon</mat-label>
        <input
            type="text"
            matInput
            [formControl]="sampleTypeControl"
            [matAutocomplete]="auto"
            placeholder="Rechercher un produit"
            (focus)="onInputFocus()"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProductName.bind(this)">
            <mat-option *ngFor="let product of filteredProducts" [value]="product.productId">
            {{ product.productName }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="form.get('sampleType')?.hasError('required')">Champ requis</mat-error>
        </mat-form-field>
          <div class="col-sm-12 col-md-12 col-lg-4">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Lot sélectionné (optionnel)</mat-label>
              <mat-select formControlName="batchId" (selectionChange)="onLotChange($event.value)">
                <mat-option [value]="null">Aucun lot</mat-option>
                <mat-option *ngFor="let lot of lotList" [value]="lot.id">
                  {{ lot.batchName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- CLIENT -->
          <div class="col-sm-12 col-md-12 col-lg-4">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Producteur</mat-label>

              <!-- Si Lot sélectionné → affichage readonly -->
              <ng-container *ngIf="lotSelected; else clientManualSelect">
                <input matInput [value]="selectedClientName" disabled />
              </ng-container>

              <!-- Sinon → selection libre -->
              <ng-template #clientManualSelect>
                <mat-select formControlName="clientId" (selectionChange)="onClientChange($event.value)" required>
                  <mat-option *ngFor="let client of clientList" [value]="client.id">
                    {{ client.identification }} - {{ client.socialReason }}
                  </mat-option>
                </mat-select>
              </ng-template>

              <mat-error *ngIf="form.get('clientId')?.hasError('required')">Champ requis</mat-error>
            </mat-form-field>
          </div>

          <!-- TERRAIN -->
          <div class="col-sm-12 col-md-12 col-lg-4">
            <mat-form-field class="mb-25" appearance="fill">
              <mat-label>Terrain</mat-label>

              <!-- Si Lot sélectionné → affichage readonly -->
              <ng-container *ngIf="lotSelected; else terrainManualSelect">
                <input matInput [value]="selectedTerrainName" disabled />
              </ng-container>

              <!-- Sinon → selection libre filtrée par client -->
              <ng-template #terrainManualSelect>
                <mat-select formControlName="terrainId">
                <mat-option [value]="null">Aucun terrain</mat-option> <!-- option vide -->
                <mat-option *ngFor="let terrain of filteredTerrains" [value]="terrain.id">
                    {{ terrain.varPlante }}
                </mat-option>
                </mat-select>
              </ng-template>

              <mat-error *ngIf="form.get('terrainId')?.hasError('required')">Champ requis</mat-error>
            </mat-form-field>
          </div>

                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25" appearance="fill">
                          <mat-label>Collecté Par</mat-label>
                          <mat-select formControlName="collectedById" placeholder="Sélectionnez un préleveur" required>
                            <mat-option *ngFor="let user of preleveurs" [value]="user.id">
                              {{ user.name }} ({{ user.username }})
                            </mat-option>
                          </mat-select>
                          <mat-error *ngIf="form.get('collectedById')?.hasError('required')">
                            Collecté Par requis
                          </mat-error>
                        </mat-form-field>
                      </div>

                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Méthode</mat-label>
                            <input matInput formControlName="methode" placeholder="Ex. Methode">
                            <mat-error *ngIf="form.get('methode')?.hasError('required')">Collecté Par requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date de collecte</mat-label>
                            <input matInput readonly [matDatepicker]="picker"
                                   formControlName="collectionDate">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('collectionDate')?.hasError('required')">Date de collecte
                                requise
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date de réception</mat-label>
                            <input matInput readonly [matDatepicker]="picker1"
                                   formControlName="dateReception">
                            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1 class="custom-datepicker"></mat-datepicker>
                            <mat-error *ngIf="form.get('dateReception')?.hasError('required')">Date de réception
                                requise
                            </mat-error>
                        </mat-form-field>
                    </div>
                  
                      

                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Location</mat-label>
                            <input matInput formControlName="location" placeholder="Ex. Casablanca">
                            <mat-error *ngIf="form.get('location')?.hasError('required')">Source échantillion requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Date de production -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Date de production</mat-label>
        <input matInput type="date" formControlName="dateProduction">
        <mat-error *ngIf="form.get('dateProduction')?.hasError('required')">
            Date de production requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Date limite de consommation -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Date limite de consommation</mat-label>
        <input matInput type="date" formControlName="dateLimiteConsommation">
        <mat-error *ngIf="form.get('dateLimiteConsommation')?.hasError('required')">
            DLC requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Référence interne -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Référence interne</mat-label>
        <input matInput formControlName="referenceInterne" placeholder="Ex. REF-2024-001">
        <mat-error *ngIf="form.get('referenceInterne')?.hasError('required')">
            Référence requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Température prélèvement -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Température prélèvement (°C)</mat-label>
        <input matInput type="number" formControlName="temperaturePrelevement" placeholder="Ex. 4">
        <mat-error *ngIf="form.get('temperaturePrelevement')?.hasError('required')">
            Température au prélèvement requise
        </mat-error>
    </mat-form-field>
</div>

<!-- Température réception -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Température réception (°C)</mat-label>
        <input matInput type="number" formControlName="temperatureReception" placeholder="Ex. 6">
        <mat-error *ngIf="form.get('temperatureReception')?.hasError('required')">
            Température à la réception requise
        </mat-error>
    </mat-form-field>
</div>
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Volume suffisant</mat-label>
        <input matInput type="number" formControlName="volumeSuffisant" placeholder="Ex. 6">
        <mat-error *ngIf="form.get('volumeSuffisant')?.hasError('required')">
            Volume requise
        </mat-error>
    </mat-form-field>
</div>
<!-- Visa -->
<div class="col-sm-6 col-lg-4">
    <mat-form-field class="mb-25">
        <mat-label>Visa</mat-label>
        <input matInput formControlName="visa" placeholder="Visa qualité">
        <mat-error *ngIf="form.get('visa')?.hasError('required')">
            Visa requis
        </mat-error>
    </mat-form-field>
</div>


                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Quantité prélevée</mat-label>
                            <input matInput type="number" formControlName="qtePre" placeholder="Ex. 1">
                            <mat-error *ngIf="form.get('qtePre')?.hasError('required')">Quantité prélevée requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                    priorite-->
                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Priorite</mat-label>
                            <input matInput type="number" formControlName="priorite" placeholder="Ex. 1">
                            <mat-error *ngIf="form.get('priorite')?.hasError('required')">Quantité prélevée requis
                            </mat-error>

                            <mat-error *ngIf="form.get('priorite')?.hasError('min')">La Priorité doit être supérieure ou égale 1 .</mat-error>
                            <mat-error *ngIf="form.get('priorite')?.hasError('max')">La Priorité doit être inférieure ou égale 3.</mat-error>
                        </mat-form-field>
                    </div>


                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>volume</mat-label>
                            <input matInput formControlName="volume" placeholder="Ex. volume">
                            <mat-error *ngIf="form.get('volume')?.hasError('required')">volume requis
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Conformité</mat-label>
                            <mat-select matSelect formControlName="sampStatus" placeholder="Sélectionner la conformité">
                                <mat-option [value]="'CONFORME'">Conforme</mat-option>
                                <mat-option [value]="'NON_CONFORME'">Non conforme</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    
                    <div class="col-sm-12 col-lg-12 mb-4" *ngIf="form.get('sampStatus')?.value === 'NON_CONFORME'">
                        <mat-form-field>
                            <mat-label>Note (Motif de rejet)</mat-label>
                            <textarea matInput formControlName="note" placeholder="Ex. échantillon du ..."></textarea>
                        </mat-form-field>
                    </div>
                    

                    <div class="col-sm-12 col-lg-12 mb-4">
                        <mat-form-field>
                            <mat-label>Commentaire</mat-label>
                            <textarea matInput formControlName="comments"
                                      placeholder="Ex. échantillon du ..."></textarea>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Matrices</mat-label>
                            <mat-select matSelect formControlName="matriceId" placeholder="Selectionner la matrice"
                                        (selectionChange)="fetchTypeAnalyseList()">
                                @for (mat of matriceList; track mat.id) {
                                    <mat-option [value]="mat.id">{{ mat.nom }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('matriceId')?.hasError('required')">Champ requis</mat-error>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Type d'analyse</mat-label>
                            <mat-select matSelect formControlName="idAT"
                                        (selectionChange)="fetchParametres()">
                                @for (st of typeAnalyseList; track st.id) {
                                    <mat-option [value]="st.id">{{ st.codeAT }}</mat-option>
                                }
                            </mat-select>
                            <mat-error *ngIf="form.get('idAT')?.hasError('required')">Champ requis
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!--                    Parametre-->
                    <div class="col-sm-6 col-lg-12 pt-3 border-top p-3">
                        <div class="fw-bold">Parametres :</div>
                    
                        <!-- Vérification si matriceId et idAT sont renseignés -->
                        <div *ngIf="!form.value.matriceId || !form.value.idAT">
                        </div>
                        <div *ngIf="form.value.matriceId && form.value.idAT">
                            <div *ngIf="paramList.length === 0">Aucun paramètre disponible pour ce type d'analyse.</div>
                            <div *ngFor="let param of paramList; trackBy: trackByFn">
                                <div class="row mt-3">
                                    <div class="col-sm-6 col-lg-3">
                                        <div class="fw-bold">Code Paramètre :</div>
                                        <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
                                    </div>
                                    <div class="col-sm-6 col-lg-3">
                                        <div class="fw-bold">Norme :</div>
                                        <p>{{ param.description || 'N/A' }} </p>
                                    </div>
                                    <div class="col-sm-6 col-lg-3">
                                        <div class="fw-bold">Description :</div>
                                        <p>{{ param.norme }} </p>
                                    </div>
                                    <div class="col-sm-6 col-lg-3">
                                        <div class="fw-bold">Technique :</div>
                                        <p>{{ param.technique }} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                  
                  
                <div class="col-sm-12 text-right mt-3" >
                    <button class="btn btn-primary" style="margin-right: 15px;" [disabled]="isSubmitting" (click)="saveSample(true)">
                        Créer un autre échantillon
                    </button>
                    <button type="submit" class="btn btn-outline-success">Créer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>

<!-- modal template for infos -->
<ng-template #viewModal let-modal>
  <mat-card class="daxa-card border-radius bg-white border-none d-block">
    <h5 class="fw-bold mx-3">Détails échantillon</h5>
    <div class="row m-3">

      <!-- 1. Code échantillon -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Code échantillon :</div>
        <p>{{ form.get('sampleCode')?.value }}</p>
      </div>

      <!-- 2. Client / Raison sociale -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Client :</div>
        <p>{{ form.get('socialReason')?.value }}</p>
      </div>

      <!-- 3. Matrice -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Matrice :</div>
        <p>{{ form.get('matriceName')?.value }}</p>
      </div>

      <!-- 4. Code type d'analyse -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Code type d'analyse :</div>
        <p>{{ form.get('codeAT')?.value }}</p>
      </div>

      <!-- 5. Méthode -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Méthode :</div>
        <p>{{ form.get('methode')?.value }}</p>
      </div>

      <!-- 6. Lot -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Lot :</div>
        <p>{{ form.get('batchName')?.value }}</p>
      </div>

      <!-- 7. Type d'échantillon -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Type d'échantillon :</div>
        <p>{{ getProductName(form.get('sampleType')?.value) }}</p>
      </div>

      <!-- 8. Statut -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Statut :</div>
        <p>{{ form.get('sampStatus')?.value }}</p>
      </div>

      <!-- 9. Collecté par -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Collecté par :</div>
        <p>{{ form.get('collectedByName')?.value }}</p>
      </div>

      <!-- 10. Date de collecte -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date de collecte :</div>
        <p>{{ form.get('collectionDate')?.value | date:'short' }}</p>
      </div>

      <!-- 11. Date de réception (conditionnelle) -->
      <div *ngIf="hasNotRole('ROLE_ADMIN')" class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date de réception :</div>
        <p>{{ form.get('dateReception')?.value | date:'short' }}</p>
      </div>

      <!-- 12. Quantité prélevée -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Quantité prélevée :</div>
        <p>{{ form.get('qtePre')?.value }}</p>
      </div>

      <!-- 13. Priorité -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Priorité :</div>
        <p>{{ form.get('priorite')?.value }}</p>
      </div>

      <!-- 15. Volume -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Volume :</div>
        <p>{{ form.get('volume')?.value }}</p>
      </div>

      <!-- 16. Température prélèvement -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Température prélèvement (°C) :</div>
        <p>{{ form.get('temperaturePrelevement')?.value }}</p>
      </div>

      <!-- 17. Température réception -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Température réception (°C) :</div>
        <p>{{ form.get('temperatureReception')?.value }}</p>
      </div>

      <!-- 18. Location -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Location :</div>
        <p>{{ form.get('location')?.value }}</p>
      </div>

      <!-- 19. Créé par -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Créé par :</div>
        <p>{{ form.get('nameCreatedBy')?.value }}</p>
      </div>

      <!-- 20. Date de création -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Créé le :</div>
        <p>{{ form.get('creationDate')?.value | date:'short' }}</p>
      </div>

      <!-- 21. Date de mise à jour -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Modifié le :</div>
        <p>{{ form.get('updateDate')?.value | date:'short' }}</p>
      </div>

      <!-- 22. Note -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Note :</div>
        <p>{{ form.get('note')?.value }}</p>
      </div>

      <!-- 23. Commentaire -->
      <div class="col-sm-12 col-lg-12 p-3 border-top">
        <div class="fw-bold">Commentaire :</div>
        <p>{{ form.get('comments')?.value }}</p>
      </div>

      <!-- 24. Date de production -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date de production :</div>
        <p>{{ form.get('dateProduction')?.value | date:'dd/MM/yyyy' }}</p>
      </div>

      <!-- 25. Date limite de consommation -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Date limite de consommation :</div>
        <p>{{ form.get('dateLimiteConsommation')?.value | date:'dd/MM/yyyy' }}</p>
      </div>

      <!-- 26. Référence interne -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Référence interne :</div>
        <p>{{ form.get('referenceInterne')?.value }}</p>
      </div>

      <!-- 27. Visa -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Visa :</div>
        <p>{{ form.get('visa')?.value }}</p>
      </div>

      <!-- 28. Terrain -->
      <div class="col-sm-6 col-lg-4 border-top p-3">
        <div class="fw-bold">Terrain :</div>
        <p>{{ form.get('terrainName')?.value }}</p>
      </div>

      <!-- 29. Paramètres -->
      <div class="col-sm-6 col-lg-12 pt-3 border-top p-3">
        <div class="fw-bold">Paramètres :</div>
        <ng-container *ngIf="paramList.length > 0; else noParams">
          <div *ngFor="let param of paramList; let i = index" class="row mt-3">
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Code Paramètre :</div>
              <p>{{ param.codeParameter || param.pesticideName || 'N/A' }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Norme :</div>
              <p>{{ param.description || 'N/A' }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Description :</div>
              <p>{{ param.norme }}</p>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="fw-bold">Technique :</div>
              <p>{{ param.technique }}</p>
            </div>
          </div>
        </ng-container>
        <ng-template #noParams>Aucun paramètre</ng-template>
      </div>

    </div>
  </mat-card>
</ng-template>

<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>


<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>



<!-- Add modal template for import ResultDTO -->
<ng-template #importModal>
    <mat-card class="daxa-card border-radius border-none d-block">
        <h4>Importer les résultats</h4>
        <div class="px-4">
            <h5 class="mt-4 text-primary">
                Depuis Text
            </h5>

            <div class="row">
                <div class="col-md-8">
                    <input class="form-control" type="file" (change)="event = $event" accept=".txt"/>
                </div>
                <div disabled="" class="col-md-2">
                    <button class="btn btn-primary rounded-pil" (click)="btnAddFromText()"
                            [disabled]="event == null">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="px-4">
            <h5 class="mt-4 text-success">
                Depuis Excel
            </h5>

            <div class="row">
                <div class="col-md-8">
                    <input class="form-control" type="file" (change)="ex_event = $event" accept=".xlsx, .xls"/>
                </div>
                <div disabled="" class="col-md-2">
                    <button class="btn btn-success rounded-pil" (click)="btn_ImportFromExcelFile()"
                            [disabled]="ex_event == null">
                        <i class="fa-solid fa-paper-plane"></i>
                    </button>
                </div>
            </div>
        </div>

    </mat-card>
</ng-template>

<ng-template #rapportModal>
  <mat-card class="daxa-card border-radius border-none d-block">
    <h4>Génération du rapport</h4>

    <div class="px-4 mt-4">

      <!-- Pays -->
      <div class="row mb-3">
        <div class="col-lg-12">
          <label>Pays</label>
          <select class="form-control" [(ngModel)]="rapportForm.country">
            <option value="FR">Europe</option>
            <option value="MA">Maroc</option>
            <option value="US">USA</option>
          </select>
        </div>
      </div>
      <!-- LQ 
      <div class="row mb-4">
        <div class="col-lg-12">
          <label>LQ (mg/kg)</label>
          <input
            type="number"
            step="0.001"
            class="form-control"
            [(ngModel)]="rapportForm.lq"
          />
        </div>
      </div>-->
      <div class="row mb-3">
  <div class="col-lg-12">
    <label>Format du rapport</label>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="format" value="pdf" [(ngModel)]="rapportForm.format" checked>
      <label class="form-check-label">PDF</label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="format" value="word" [(ngModel)]="rapportForm.format">
      <label class="form-check-label">Word</label>
    </div>
  </div>
</div>


      <!-- Actions -->
      <div class="text-end">
        <button
          class="btn btn-primary btn-sm"
          [disabled]="loadingRapport"
          (click)="confirmAndGenerateRapport()"
        >
          Générer le rapport
        </button>
      </div>

    </div>
  </mat-card>
</ng-template>

